// extracted by mini-css-extract-plugin
export default {"container":"CategoryFilters__container--Xx_qR","resetButton":"CategoryFilters__resetButton--2xt4W"};